import {
  Injectable,
  Output,
  EventEmitter,
  Injector,
  Compiler,
  ComponentFactoryResolver,
  Inject,
  NgModuleFactory,
  Type,
  ViewContainerRef
} from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TWADialogsService {

  twaDialogsModule!: any;
  twaPromptDialogsModule!: any;
  twaConfirmDialogsModule!: any;
  vcr!: ViewContainerRef;

  constructor(
    private dialog: MatDialog,
    private _sanitizer: DomSanitizer
  ) { }

  async loadTWADialogs() {
    if (!this.twaPromptDialogsModule) {
      const { TWADialogsModule } = await import('./../../../projects/twa-md2-dialogs/src/lib/twa-dialogs.module');
      // const { TWADialogsModule } = await import('twa-md2-dialogs');
      this.twaDialogsModule = new TWADialogsModule(this.dialog, this._sanitizer);

    }
  }

  prompt(title: string, text: string, form: any, ok?: string, cancel?: string, onChange?: any, options?: any, dialogOptions?: any): Observable<any> {
    return new Observable((observer) => {
      this.loadTWADialogs().then(_ => {
        this.twaDialogsModule.prompt(title, text, form, ok, cancel, onChange, options, dialogOptions).subscribe((res: any) => observer.next(res));
      });
    });
  }

  confirm(title: string, text: string, ok?: string, cancel?: string, dialogOptions?: any): Observable<any> {
    return new Observable((observer) => {
      this.loadTWADialogs().then(_ => {
        this.twaDialogsModule.confirm(title, text, ok, cancel, dialogOptions).subscribe((res: any) => observer.next(res));
      });

    });
  }

}
